import { __assign } from "tslib";
export var createPropsGetter = function (defaultProps) {
    return function (props) {
        return __assign(__assign({}, defaultProps), props);
    };
};
